import React from 'react'
import {Row, Col} from 'reactstrap'
import PropTypes from 'prop-types'

const TimesheetSummary = ({label, days, values}) => {

    return (<Row style={{paddingTop: '20px', fontWeight: 'bold'}}>
        <Col className="col-2 float-right">
            <span className="text-muted"><small>{label}</small></span>
        </Col>
        {days.map((day, index) => (
            <Col key={index} style={{textAlign: 'center'}}>
                <span className="text-muted"><small>{values[day] || 0}</small></span>
            </Col>
        ))}
    </Row>)

}

TimesheetSummary.propTypes = {
    label: PropTypes.string,
    days: PropTypes.array,
    values: PropTypes.object
}

export default TimesheetSummary